// extracted by mini-css-extract-plugin
export var location = "map-module--location--1Onpj";
export var map = "map-module--map--X+ygh";